import _ from 'lodash';
import { log } from '@swiper/core';
import { Service } from './Service';
import Promise from 'bluebird';

export class PresenceService extends Service {

  get name() { return 'presence'; }

  constructor( opts ) {
    super( opts );
    this.data = {};
  }

  async setup( ...args ) {
    await super.setup( ...args );
    /*
    await this.loadAllSessions();
    const sessions = this.app.service( 'sessions' );
    sessions.on( 'created', ( message, context ) => {
      console.log( 'SESSION created', message );
    } );
    sessions.on( 'updated', ( message, context ) => {
      console.log( 'SESSION updated', message );
    } );
    sessions.on( 'patched', ( message, context ) => {
      console.log( 'SESSION patched', message );
    } );
    sessions.on( 'removed', ( message, context ) => {
      console.log( 'SESSION removed', message );
    } );
    */
  }

  /*
    const presence = _.map( _.flatten( _.at( session, [
      'members', 'friends', 'guests',
    ] ) ), person => {
      return _.assign( {}, { session : session.id }, _.pick( person, [
        'id', 'name', 'type', 'membershipId', 'present',
      ] ) );
    } );
    log.debug( 'PRESENCE UPDATE', presence );
    await this.app.service( 'presence' ).create( presence );
*/

  async find( params ) {
    return _.filter( this.data, params.query || {} );
  }

  async loadAllSessions() {
    const sessions = this.app.service( 'sessions' );
    const ids = await sessions.list();
    for ( const id of ids ) {
      // eslint-disable-next-line no-await-in-loop
      await sessions.get( id );
    }
    log.debug( 'PRESENCE LOADED', _.keys( this.data ) );
  }

  async create( data, params ) {
    if ( params.provider ) return; // Don't allow external updates
    if ( ! _.isArray( data ) ) this.throw( 'BadRequest', `Expected an array` );
    return Promise.map( data, person => {
      if ( person.present ) {
        this.data[ person.id ] = person;
      } else {
        delete this.data[ person.id ];
      }
    } );
  }

}
